export default function HeroSection() {
  const handleNav = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative w-full min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: "url('https://static.readdy.ai/image/0b053ca972f96e6a72462b3430aa5d72/942cac6ab89dcab6417d4154bccde99e.jpeg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80"></div>

      {/* Content */}
      <div className="relative z-10 w-full flex flex-col items-center text-center px-4">
        <img
          src="https://static.readdy.ai/image/0b053ca972f96e6a72462b3430aa5d72/93c690249b0a54bf013dcb2eccebae8b.jpeg"
          alt="Club Logo"
          className="w-28 h-28 rounded-full object-cover border-4 border-red-600 mb-8"
        />
        <p className="text-red-500 uppercase tracking-[0.4em] text-sm font-bold mb-4">Est. 2026</p>
        <h1 className="text-5xl md:text-7xl font-black text-white uppercase leading-tight mb-4" style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: "0.05em" }}>
          respect Motorcycle Club<br />
          <span className="text-red-600">Respect Social Club / Respect Auto Club</span>
        </h1>
        <p className="text-gray-300 text-lg md:text-xl italic max-w-xl mb-10">
          Ride together. Stand together. <span className="text-white font-semibold not-italic">Brotherhood for life.</span>
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <button
            onClick={() => handleNav("membership")}
            className="bg-red-700 hover:bg-red-600 text-white uppercase font-bold tracking-widest px-10 py-4 text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Become a Member
          </button>
          <button
            onClick={() => handleNav("events")}
            className="border-2 border-white text-white hover:bg-white hover:text-black uppercase font-bold tracking-widest px-10 py-4 text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            View Events
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-gray-400 text-xs uppercase tracking-widest">Scroll</span>
        <i className="ri-arrow-down-line text-gray-400 text-xl"></i>
      </div>
    </section>
  );
}
